import React from 'react';

import { Icon } from '@atom/mui';
import { type IconComponent } from '@atom/mui/icons';

import classes from './field.module.css';

export interface Props {
  icon?: IconComponent;
  iconColor?: string;
  label?: string;
  input: React.ReactNode;
}

const Field = ({ icon, iconColor, label, input }: Props) => (
  <div className={classes.field}>
    <div className={classes.fieldIcon}>
      {icon && <Icon color={iconColor} icon={icon} />}
    </div>
    <div className={classes.fieldContent}>
      {label && <div className={classes.fieldTitle}>{label}</div>}
      <div className={classes.fieldComponent}>{input}</div>
    </div>
  </div>
);

export default Field;
